/**
 * auth.js
 * Path: frontend/src/api/auth.js
 * Description: Wywołania API autoryzacji.
 * Related: context/AuthContext.js, hooks/useAuth.js
 */

import { api, authHeaders } from "./apiBase";

export async function loginRequest(email, password) {
  const response = await api.post("/auth/login", { email, password });
  return response.data;
}

export async function setupPasswordRequest(setupToken, password, confirmPassword) {
  const response = await api.post("/auth/setup-password", { setupToken, password, confirmPassword });
  return response.data;
}

export async function changePasswordRequest(token, currentPassword, newPassword, confirmPassword) {
  const response = await api.post(
    "/auth/change-password",
    { currentPassword, newPassword, confirmPassword },
    { headers: authHeaders(token) }
  );
  return response.data;
}

export async function fetchProfile(token) {
  const response = await api.get("/auth/me", { headers: authHeaders(token) });
  return response.data;
}

